import { makeStyles } from '@mui/styles';
import TextField from 'apollo-react/components/TextField';
import React, { useCallback } from 'react';
import { useSelector } from 'react-redux';

import ZoomControl from './Zoom';
import { getLookupError } from '../../selectors/export.selectors';

const useStyles = makeStyles({
  controlWrapper: {
    position: 'relative',
    margin: '5px 0px',
  },
});

const LookupField = ({
  actorsTableKey,
  rowId,
  value = '',
  entityName,
  savedSearchName = '',
  isAutoCompleteLoading = false,
  handleSelect,
  multiSelect,
}) => {
  const classes = useStyles();
  const error = useSelector((state) => getLookupError(state, { rowId }));

  const handleOnSelect = useCallback(
    (selection) => {
      handleSelect({ rowId, actorsTableKey, data: selection });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    []
  );

  return (
    <div className={classes.controlWrapper}>
      <TextField asteriskPosition="before" fullWidth value={value} error={!!error} required />
      <ZoomControl
        entityName={entityName}
        savedSearchName={savedSearchName}
        handleOnSelect={handleOnSelect}
        isAutoCompleteLoading={isAutoCompleteLoading}
        multiSelect={multiSelect}
      />
    </div>
  );
};

export default LookupField;
